import {
  Card,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import React, { useEffect } from 'react'
import { FormattedDateTime } from '../../formatted-date-time'
import { TruncatedId } from '../../truncated-id'
import { Spacer } from '@vestaboard/installables'
import { useSearchByBoiSerial } from '../hooks/useSearchByBoiSerial'

interface ISearchBoiSerial {
  boiSerialNumber: string
}

export const SearchBoiSerialComponent = (props: ISearchBoiSerial) => {
  const [searchByBoiSerial, { data, loading }] = useSearchByBoiSerial()

  useEffect(() => {
    searchByBoiSerial({
      variables: {
        input: {
          boiSerialNumber: props.boiSerialNumber
        }
      }
    })
  }, [props.boiSerialNumber, searchByBoiSerial])

  if (loading) {
    return <CircularProgress />
  }

  const device = data?.searchByBoiSerial?.device
  const hardware = data?.searchByBoiSerial?.hardware

  if (!device && !hardware) {
    return <Alert severity='warning'>There are no devices that match the serial number "{props.boiSerialNumber}"</Alert>
  }

  return (
    <>
      <Alert severity='info'>On the bright side, we found a device with the serial number "{props.boiSerialNumber}"</Alert>
      <Spacer size='large' />
      <Card>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                {device && <TableCell>Device ID</TableCell>}
                {device && <TableCell>Device Created</TableCell>}
                {device && <TableCell>Pairing Code</TableCell>}
                {device && <TableCell>Firmware Version</TableCell>}
                {device && <TableCell>Latest Heartbeat</TableCell>}
                {device && <TableCell>SSID</TableCell>}
                <TableCell>BOI Serial Number</TableCell>
                <TableCell>Hardware ID</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                {device && (
                  <TableCell>
                    <TruncatedId value={device.id} path={`/devices/${device.id}`} />
                  </TableCell>
                )}
                {device && (
                  <TableCell>
                    <FormattedDateTime format='MM/DD/YYYY' value={+device.created} />
                  </TableCell>
                )}
                {device && <TableCell>{device.pairingCode || ''}</TableCell>}
                {device && <TableCell>{device.firmwareVersion || 'Unknown'}</TableCell>}
                {device && (
                  <TableCell>
                    {device.latestHeartbeat?.created ? (
                      <FormattedDateTime format='MM/DD/YYYY' value={+device.latestHeartbeat?.created} />
                    ) : (
                      ''
                    )}
                  </TableCell>
                )}
                {device && <TableCell>{device.configurationNetwork?.ssid || ''}</TableCell>}
                <TableCell>{hardware?.boiSerialNumber || ''}</TableCell>
                <TableCell>{hardware?.id ? <TruncatedId value={hardware.id} /> : ''}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </>
  )
}
